import type { DeleteControlGroupMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import {
  DeleteControlGroupDocument,
  GetControlGroupsFlatDocument,
  namedOperations,
} from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useDeleteControlGroup = createMutationHook({
  name: 'deleteControlGroup',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.controlGroup.delete.mutationOptions({ onSuccess }),
  mapInput: (input: { id: string; modifiedAtTimestamp: string }) => ({
    id: input.id,
    originalTimestamp: input.modifiedAtTimestamp,
  }),
  invalidate: (trpc) => [
    trpc.frontend.controlGroup.controlGroupById.queryKey(),
    trpc.frontend.controlGroup.controlGroups.queryKey(),
    trpc.frontend.controlGroup.controlGroupsByTitle.queryKey(),
    trpc.frontend.controlGroup.register.queryKey(),
    // COI-889: the left-nav badge reads this count family.
    trpc.frontend.controlGroup.controlGroupCount.queryKey(),
    // COI-889: the control register renders `parents.group.Title`, and the
    // Apollo leg refetches `getControlById`; the tRPC leg had no equivalent.
    trpc.frontend.control.pathKey(),
  ],
  // trpc should throw an error if no rows are affected
  mapResponse: (): DeleteControlGroupMutation => ({
    delete_control_group: {
      __typename: 'control_group_mutation_response',
      affected_rows: 1,
    },
  }),
  graphqlDocument: DeleteControlGroupDocument,
  graphqlVariables: (input: { id: string; modifiedAtTimestamp: string }) => ({
    id: input.id,
    original_timestamp: input.modifiedAtTimestamp,
  }),
  evictFields: ['control_group', 'control_group_aggregate'],
  refetchQueries: [
    namedOperations.Query.getControlById,
    { query: GetControlGroupsFlatDocument },
  ],
  awaitRefetchQueries: true,
});
